import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../../../design/modals/modal/S_Modal';
import { UpdateWorkspaceTimeZoneFormContainer } from '../containers/UpdateWorkspaceTimeZoneForm.container';
import { UpdateWorkspaceTimeZoneSubmitButtonContainer } from '../containers/UpdateWorkspaceTimeZoneSubmitButton.container';

interface IProps {
  showModal: boolean;
  onHideModal: () => void;
}

export const UpdateWorkspaceTimeZoneModal = ({ showModal, onHideModal }: IProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <S_Modal
      isOpen={showModal}
      toggle={onHideModal}
      headerText={t('update_workspace_timezone')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={onHideModal}
          >
            {t('workspace_cancel')}
          </Button>
          <UpdateWorkspaceTimeZoneSubmitButtonContainer />
        </>
      }
    >
      <UpdateWorkspaceTimeZoneFormContainer />
    </S_Modal>
  );
};
